<template>
  <div class="position-relative" style="background-color:white" v-if="visible">
    <admin-box-item title="요일별 가격 적용 기간 설정">
      <!-- 일 -->
      <div class="flex-between" style="margin-bottom:28px">
        <i class="material-icons unselect" style="background-color:#eef1f3" @click="prevMonth">keyboard_arrow_left</i>
        <div style="font-size:16px;font-weight:bold;">{{ calendar.year }}년 {{ calendar.month }}월</div>
        <i class="material-icons unselect" style="background-color:#eef1f3" @click="nextMonth">keyboard_arrow_right</i>
      </div>
      <!-- 요일 -->
      <div class="flex lp-days">
        <div class="lp-day"
             :style="dayTitleStyle(idx)"
             v-for="(day,idx) in days" :key="'day-'+idx">{{ day }}</div>
      </div>
      <div class="flex wrap lp-dates">
        <div class="lp-date unselect position-relative"
             v-for="(date,idx) in calendar.dates"
             :key="'date-'+idx"
             @click="clickDate(date,idx)"
             :style="dayWrapStyle(date)">
          <div class="flex-center" :style="dayStyle(date)">
            <!-- 일자 표시 -->
            <div class="position-absolute size-13 date-number">{{ date.day > 0 ? date.day : '' }}</div>
          </div>
        </div>
      </div>
      <div class="btn-group-justify-end">
        <button class="button is-grey-light" @click="$emit('cancel')">취소</button>
        <button class="button is-primary" @click="clickOk">확인</button>
      </div>

<!--      <div class="flex-between position-absolute" style="bottom:0;width:100%;padding:8px 20px;background-color:white;border: 1px solid #eee">-->
        <!--<div>
          <div>{{ selectedDate }}</div>
          <div v-if="!btnEnable" class="size-12">최소 {{ minPeriodDate }}이상 선택해야 예약이 가능합니다</div>
        </div>-->
<!--      </div>-->
    </admin-box-item>
  </div>
</template>
<script>
  import moment from 'moment';
  export default {
    name: 'ModalDateRangePicker',
    components: {

    },
    mixins: [

    ],
    props: {
      date_range: {
        type: Array,
        required: false
      },
      excludeDateRangeArr: {
        type: Array
      }
    },
    data() {
      return {
        "max": 1,
        "days": [
          "일",
          "월",
          "화",
          "수",
          "목",
          "금",
          "토"
        ],
        "touch": 0,
        "maximum": 1,
        "minimum": 1,
        "visible": false,
        "calendar": undefined,
        "end_date": "",
        "start_date": "",
        "currentDate": undefined
      }
    },
    created() {
      // this.$axios.get(`user/0/mapping/product/${this.$route.query.id}?fields=minimum,maximum`).then(res => {
      //
      // });
      this.minimum = 1;
      this.maximum = 1;
      this.initDateRange();
      this.setDates();
    },

    methods: {
      initDateRange () {
        if(this.date_range && this.date_range.length>0) {
          let start = this.date_range[0];
          let end = this.date_range[1];
          let start_date = moment(start);
          let end_date = moment(end);
          this.start_date = {
            year: start_date.year(),
            month: start_date.month()+1,
            day: start_date.date()
          };
          this.end_date = {
            year: end_date.year(),
            month: end_date.month()+1,
            day: end_date.date()
          };
          this.currentDate = start_date;
        }
        else {
          this.currentDate = this.moment();
        }
      },
      nextMonth () {
        this.currentDate = this.currentDate.add(1, 'month');
        this.setDates();
      },
      prevMonth () {
        this.currentDate = this.currentDate.subtract(1, 'month');
        this.setDates();
      },
      dateFormat(dt, type) {
        if (!dt) return '';

        if (type === 'ago') {
          return moment(dt).fromNow();
        }

        let format = '';
        switch (type) {
          case 'date_time_1':
            format = 'YY년 MM월 DD일(dd) HH시 mm분'
            break;
          case 'date_time_2':
            format = 'YYYY-MM-DD HH:mm'
            break;
          case 'date_time_3':
            format = 'YY/MM/DD HH:mm'
            break;
          case 'date_time_4':
            format = 'YY.MM.DD HH:mm'
            break;
          case 'date_1':
            format = 'YY년 MM월 DD일(dd)'
            break;
          case 'date_2':
            format = 'YY년 MM월 DD일'
            break;
          case 'date_3':
            format = 'YYYY.MM.DD'
            break;
          case 'date_4':
            format = 'YYYY-MM-DD'
            break;
          case 'date_5':
            format = 'MM월 DD일(dd)'
            break;
          case 'date_6':
            format = 'MM.DD(dd)'
            break;
          case 'date_7':
            format = 'MM월 DD일'
            break;
          case 'date_8':
            format = 'YYYY년 MM월 DD일(ddd)'
            break;
          case 'date_9':
            format = 'YYYY년 MM월 DD일 dddd'
            break;
          case 'time_1':
            format = 'HH시 mm분'
            break;
          case 'year_1':
            format = 'YYYY'
            break;
          case 'month_1':
            format = 'MM'
            break;
          case 'day_1':
            format = 'DD'
            break;
        }
        return moment(dt).format(format);
      },
      // 선택완료
      clickOk() {
        if(this.touch===0) {
          this.toast('기간을 선택해주세요.');
          return;
        }
        else if(this.touch===1) {
          this.toast('종료날짜를 선택하세요.')
          return;
        }
        // this.$emit('date_range', [this.period.resv_date, this.period.resv_end_date]);
        if(this.period.resv_date && this.period.resv_end_date) {
          this.$emit('clickResv', [this.period.resv_date, this.period.resv_end_date]);
        }
        /*else {
          this.toast('기간을 선택해주세요.');
          return;
        }*/
      },
      // 날짜 선택
      clickDate(date) {
        if(date.prev || !date.enable) {
          return;
        }
        /*if(this.start_date.year >= date.year && this.start_date.month >= date.month && this.start_date.day >= date.day) {
          this.touch = 1;
          this.start_date = date;
          this.end_date = date;
        }*/
        // 선택한 날짜가 최대 선택가능한 일 수 보다 넘치는 경우
       /* else if(this.calcPeriod(this.start_date, date) > this.maximum) {
          this.touch = 1;
          this.start_date = date;
          this.end_date = date;
        }*/
        // 1번쨰 터치할 경우
        else if(this.touch===0) {
          this.touch += 1; // touch=1
          this.start_date = date;
          this.end_date = date;
        }
        // 2번쨰 터치할 경우
        else if(this.touch===1) {
          // 같은 날짜 선택
          if(this.start_date.year === date.year && this.start_date.month === date.month && this.start_date.day === date.day) {
            this.end_date = date;
          }
          // 다른 날짜 선택
          else {
            // 선택한 날짜가 기존 날짜보다 전일 경우 예외처리
            let start_d = moment(`${(this.start_date.year).toString()}-${(this.start_date.month).toString()}-${(this.start_date.day).toString()}`);
            let sel_d = moment(`${(date.year).toString()}-${(date.month).toString()}-${(date.day).toString()}`);
            if(sel_d.isBefore(start_d)) {
              this.touch = 1;
              this.start_date = date;
              this.end_date = date;
            }
            else {
              let start = this.start_date;
              let end = date;
              let start_date = this.dateFormat(this.dateToStr(start), 'date_3');
              let end_date = this.dateFormat(this.dateToStr(end), 'date_3');

              // 기간안에 예약가능한 날짜가 없을 경우 선택한 날짜 단일 선택으로 변경
              let cal = this.calendar;
              for(let j=0; j<cal.dates.length; j++) {
                let dates = cal.dates[j];
                let date_item = this.dateFormat(this.dateToStr(dates), 'date_3');

                if(this.moment(start_date).isBefore(date_item) && this.moment(date_item).isBefore(end_date)) {
                  if(!dates.enable) {
                    this.start_date = date;
                    this.end_date = date;
                    this.touch = 1;
                    return;
                  }
                }
              }

              this.touch += 1; // touch=2
              this.end_date = date;
            }
          }
        }
        // 3번쨰 터치할 경우
        else if(this.touch===2) {
          this.start_date = date;
          this.end_date = date;
          this.touch = 1;
        }

      },
      dateToStr(date) {
        if(date==='') return '';
        if(date.day === '') return '';
        return '%d-%02d-%02d'.format(date.year, date.month, date.day);
      },
      formattedDate(date) {
        return this.moment(this.dateToStr(date)).format('YY.MM.DD(dd)');
      },
      btnStyle(resv) {
        let deco = {
          borderRadius: '20px',
          padding: '5px 20px',
          textAlign: 'center',
          marginBottom: '12px'
        };
        if(resv.remain === 0) {
          deco.color = 'white';
          deco.backgroundColor = '#ddd';
        }
        else {
          if(resv.selected) {
            deco.color = 'white';
            deco.backgroundColor = 'e12e21';
          } else {
            deco.color = '#000000';
          }
          deco.border = '#000000';
        }

        return deco;
      },
      dayWrapStyle(date_val) {
        // 하루만 선택된 경우
        // let start = this.start_date;
        // let end = this.end_date;
        let deco = {

        };
        return deco;
        /*if(start === '') {
          deco.justifyContent = 'center';
          return deco;
        } else {
          let start_date = this.moment(this.dateToStr(start)).format('YYYY-MM-DD');
          let end_date = this.moment(this.dateToStr(end)).format('YYYY-MM-DD');
          let date = this.moment(this.dateToStr(date_val)).format('YYYY-MM-DD');

          // 선택한 날짜 기간에 스타일 추가
          if(this.moment(start_date).isSameOrBefore(date) && this.moment(date).isSameOrBefore(end_date)) {

            if (start_date === end_date) {
              deco.justifyContent = 'center'
            }
            // 선택 처음날짜
            else if(start_date === date) {
              deco.justifyContent = 'flex-end';
            }
            // 선택 마지막날짜
            else if(end_date === date) {
              deco.justifyContent = 'flex-start';
            }
          }

          return deco;
        }*/
      },
      dayTitleStyle (idx) {
        let deco = {
          fontWeight: 'bold',
          fontSize: '14px'
        };
        if(idx===0) {
          deco.color = '#f45853';
        }
        else if(idx===6) {
          deco.color = '#3c93cf';
        }
        return deco;
      },
      dayStyle(date_val) {
        let start = this.start_date;
        let end = this.end_date;

        let deco = {
          // borderRadius: '50%',
          color: 'white',
          width: '36px',
          height: '36px',
          lineHeight: '36px',
          // textAlign: 'center'
        };

        if(start === '') {
          deco.color = '#515151';
          deco.lineHeight = '35px';
        }
        else {
          let start_date = this.moment(this.dateToStr(start)).format('YYYY-MM-DD');
          let end_date = this.moment(this.dateToStr(end)).format('YYYY-MM-DD');
          let date = this.moment(this.dateToStr(date_val)).format('YYYY-MM-DD');

          if(this.moment(start_date).isSameOrBefore(date) && this.moment(date).isSameOrBefore(end_date) && date_val.enable) {
            deco.backgroundColor = '#e95a25';
            deco.color = 'white';
            deco.width = '36px';
            deco.borderRadius = '36px';
          }
          else {
            deco.color = '#515151';
            // deco.border = '1px solid #dddddd';
            deco.lineHeight = '35px';

            // 토요일 일요일 스타일
            let s_date = '%d%02d%02d'.format(date_val.year,date_val.month,date_val.day);
            if(moment(s_date).day()===0) {
              deco.color = '#f45853';
            }
            else if (moment(s_date).day()===6) {
              deco.color = '#3c93cf';
            }
          }
        }
        // 이전날짜 비활성화 표시
        if(date_val.prev) {
          // deco.border = '1px solid #dddddd';
          deco.color = '#e4dde4';
          deco.lineHeight = '35px';
        }
        else if(!date_val.enable) {
          deco.color = '#e4dde4';
        }

        return deco;
      },
      async setDates() {
        let currentDate = this.currentDate;

        let dates = [];
        let day = 0;

        let year = currentDate.year();
        let month = currentDate.month()+1;
        let start_day = currentDate.startOf('month').day();
        let end_date = currentDate.endOf('month').date();
        // console.log('year,month,start_day,end_date',year,month,start_day,end_date);
        // 6주일경우 42, 5주는 35
        let len = 42;
        if(start_day + end_date <= 35) {
          len = 35;
        }

        // 이전달 날짜 (prev:true)
        for(let i=start_day-1; i>=0; i--) {
          let old = this.moment(currentDate);
          old.subtract(1, 'month');
          let old_last = old.endOf('month').date();

          dates.push({
            year: old.year(),
            month: old.month()+1,
            day: old_last - i,
            prev: true,
            enable: true,
          });
        }

        // 현재달 날짜 (prev: 이전날짜는 prev: true)
        for(let i=0; i< len; i++) {
          // console.log('i, day, start_day, end_date', i, day, start_day, end_date)
          if(i>=start_day && day<end_date) {
            let date = {
              year: year,
              month: month,
              day: ++day,
              enable: true,
            };
            // console.log('날짜',year, month, day)
            date.prev = this.moment('%d-%02d-%02d'.format(year,month,day)).isBefore(this.moment());
            dates.push(date);
          }
        }

        this.calendar = {"year": year, "month": month, "dates": dates};

        this.duplicateDateRangeArrCheck();

        this.visible = true;
      },
      // 기간 중복 체크 해서 비활성화
      duplicateDateRangeArrCheck() {
        for(let x=0; x<this.calendar.dates.length; x++) {
          let date = this.calendar.dates[x];
          let s_date = '%d%02d%02d'.format(date.year,date.month,date.day);

          this.excludeDateRangeArr.forEach(item => {
            let start = item[0].replace('-', '').replace('-', '');
            let end = item[1].replace('-', '').replace('-', '');

            if(parseInt(start) <= parseInt(s_date) && parseInt(s_date) <= parseInt(end)) {
              // console.log('string date', s_date, `${start} ~ ${end}`)
              date.enable = false;
            }
          })
        }
      },
      calcPeriod(start_date, end_date) {
        if(!start_date) {
          return 0;
        }
        let resv_date = this.dateFormat(this.dateToStr(start_date), 'date_4');
        let resv_end_date = this.dateFormat(this.dateToStr(end_date), 'date_4');
        return this.moment(resv_end_date).diff(this.moment(resv_date), 'days') + 1;
      }
    },
    computed: {
      minPeriodDate() {
        let date = this.minimum;
        return date>1 ? `${date-1}박 ${date}일` : `무박 ${date}일`;
        //return date>1 ? `${date-1}박` : `무박`;
      },
      selectedDate() {
        if(this.start_date && this.end_date) {
          let start_date = this.formattedDate(this.start_date);
          let end_date = this.formattedDate(this.end_date);

          if(start_date===end_date) {
            return start_date;
          }
          else {
            return `${start_date} - ${end_date}`;
          }
        }
        else return '';
      },
      period() {
        let resv_date = this.dateFormat(this.dateToStr(this.start_date), 'date_4');
        let resv_end_date = this.dateFormat(this.dateToStr(this.end_date), 'date_4');
        return {
          period: true,
          resv_date: resv_date,
          resv_end_date: resv_end_date,
          days: this.moment(resv_end_date).diff(this.moment(resv_date), 'days')
        }
      },
      btnEnable() {
        return (this.period.days+1) >= this.minimum;
      },
      btnColor() {
        if(this.btnEnable) {
          return {
            color: 'white',
            bg: '#000000'
          }
        } else {
          return {
            color: 'white',
            bg: '#e12e21'
          }
        }
      },
      customStyle() {
        return {
          borderRadius: '8px'
        }
      }
    },
    watch: {
      date_range: {
        handler(n) {
          this.initDateRange();
        },
        deep: true
      }
    }
  }
</script>
<style scoped>
  .lp-month {
    font-size: 15px;
    margin: 0 12px;
  }
  .lp-days {
    padding: 12px 0;
    border-bottom: 1px solid #ddd;
    margin-bottom: 12px;
  }
  .lp-day {
    width: 14.2857%;
    text-align: center;
    padding-bottom: 4px;
    font-size: 13px;
  }
  .lp-dates {
    margin-bottom: 20px;
  }
  .lp-date {
    width: 14.2857%;
    height: 14.2857%;
    display: flex;
    justify-content: center;
    margin: 8px 0;
  }
  .icon-arrow {
    color: #fff;
    background-color: #777;
    border-radius: 50%;
    font-size: 18px;
  }
  .box-resv {
    padding: 12px 0;
    border-top: 1px solid #ddd;
  }

  .date-number {
    height: 100%;
    width: 20px;
    text-align: center;
    top: 0;
    left: calc(50% - 10px);
  }
</style>

